let buttonAnimate = document.querySelectorAll('.button--animate');

window.onload = () => {
    if(buttonAnimate) {
        buttonHover();
    }
}

function buttonHover() {
    buttonAnimate.forEach(item => {
        item.onmousemove = function (e) {
            let x = e.pageX - item.offsetLeft;
            let y = e.pageY - item.offsetTop;

            item.style.setProperty('--x', x + 'px')
            item.style.setProperty('--y', y + 'px')
        }
    })
}